var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.order.id)?_c('order-display',{attrs:{"order":_vm.order}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }